const CLOUDFRONT_URL = "https://d34c0c1in94n75.cloudfront.net";

export const getURLColor = (selectedColor) => {
  if (!selectedColor || !selectedColor?.name) {
    return "";
  }

  const newSubColors = [];
  const subColors = selectedColor?.name?.split(" ");
  if (!subColors) {
    return newSubColors;
  }

  for (const subColor of subColors) {
    const newSubColor = subColor[0]?.toUpperCase() + subColor?.slice(1);
    newSubColors.push(newSubColor);
  }

  return newSubColors.join(" ");
};

const getCdnMappingUrl = async (dgiStyle, imgColor, imgIndex) => {
  try {
    // Only look in the S3 bucket for the mapping file
    const mappingUrl = `${CLOUDFRONT_URL}/${dgiStyle}-cdn-mappings.json`;
    
    const response = await fetch(mappingUrl);
    if (!response.ok) return null;
    
    const mappings = await response.json();
    
    // Decode the URL-encoded color name before using it as a key
    const decodedColor = decodeURIComponent(imgColor);
    const key = `${dgiStyle}-${decodedColor}-${imgIndex}`;
    
    return mappings[key] || null;
  } catch (error) {
    // Silently fail and return null
    return null;
  }
};

export const constructImageUrl = (dgiStyle, imgColor, imgIndex) => {
  const cloudfrontUrl = `${CLOUDFRONT_URL}/${dgiStyle}-${imgColor}-${imgIndex}.jpg`;
  return cloudfrontUrl;
};

export const constructSwatchImageUrl = (dgiStyle, master_color) => {
  return CLOUDFRONT_URL + "/" + dgiStyle + "-" + master_color + "-swatch.jpg";
};

export const getValidImageUrls = (dgiStyle, imgColor) => {
  const validUrls = [];
  const maxImgIndex = 9;
  let currentIndex = 0;
  while (currentIndex <= maxImgIndex) {
    const currentImgUrl = constructImageUrl(dgiStyle, imgColor, currentIndex);
    validUrls.push(currentImgUrl);
    currentIndex += 1;
  }
  return validUrls;
};

// New function to handle fallback
export const handleImageFallback = async (dgiStyle, imgColor, imgIndex) => {
  return await getCdnMappingUrl(dgiStyle, imgColor, imgIndex);
};
